<template>
  <div class="base-data-table-wrapper">
    <base-filter v-if="filterGroups.length" class="base-data-table-filter mb-2" :groups="filterGroups"
      :value="filterValue" :clearable="filterClearable" :clear-label="filterClearLabel"
      @input="$emit('update:filter-value', $event)" @change="$emit('filter-change', $event)"
      @clear="$emit('filter-clear')" />

    <v-data-table v-bind="$attrs" v-on="$listeners">
      <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import BaseFilter from "./BaseFilter.vue";

export default {
  name: "BaseDataTable",
  components: { BaseFilter },
  inheritAttrs: false,
  props: {
    // Optional: passing groups renders a BaseFilter bar above the table.
    filterGroups: {
      type: Array,
      default: () => [],
    },
    filterValue: {
      type: Object,
      default: () => ({}),
    },
    filterClearable: {
      type: Boolean,
      default: true,
    },
    filterClearLabel: {
      type: String,
      default: "Clear",
    },
  },
};
</script>
